import { useEffect, useState } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export default function Works() {
    // Daftar project (dummy)
    const projects = [
        { id: 1, title: "Concept Design", image: "/images/1.jpg", description: "Concept Design Video Wall System" },
        { id: 2, title: "Concept Design", image: "/images/3.jpg", description: "Concept Design Motorized Screen for Meeting Room" },
        { id: 3, title: "Concept Design", image: "/images/2.jpg", description: "Concept Design Videotron System" },
        { id: 4, title: "Concept Design", image: "/images/4.jpg", description: "Concept Design Interactive Display" },
        { id: 5, title: "Concept Design", image: "/images/5.jpg", description: "Concept Design Videotron System" },
        { id: 6, title: "Concept Design", image: "/images/6.jpg", description: "Concept Design Videotron System" },
        { id: 7, title: "Concept Design", image: "/images/7.jpg", description: "Concept Design Video Wall System" },
        { id: 8, title: "Concept Design", image: "/images/8.jpg", description: "Concept Design Videotron System with Motorized Screen" },
    ];

    // State untuk modal
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProject, setSelectedProject] = useState(null);

    // Fungsi untuk membuka modal
    const openModal = (project) => {
        setSelectedProject(project);
        setIsModalOpen(true);
    };

    // Fungsi untuk menutup modal
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedProject(null);
    };

    useEffect(() => {
        // Pastikan plugin ScrollTrigger diregister
        gsap.registerPlugin(ScrollTrigger);

        // Menggunakan fromTo agar nilai awal & akhir lebih terjamin
        gsap.fromTo(
            ".work-item",
            {
                opacity: 0,
                y: 50,
            },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                stagger: 0.2,
                ease: "power3.out",
                scrollTrigger: {
                    trigger: ".works-page",
                    start: "top 80%",
                    immediateRender: false, // agar tidak langsung 'terpicu' sebelum scroll
                },
            }
        );
    }, []);

    return (
        <section className="works-page section">
            <div className="container">
                <h2 className="section-title">All Projects</h2>
                <div className="works-grid">
                    {projects.map((project) => (
                        <div key={project.id} className="work-item" onClick={() => openModal(project)}>
                            <img src={project.image} alt={project.title} />
                            <div className="work-overlay">
                                <h4>{project.title}</h4>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Modal */}
                {isModalOpen && selectedProject && (
                    <div className="modal-overlay" onClick={closeModal}>
                        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                            <button className="modal-close" onClick={closeModal}>×</button>
                            <div className="modal-left">
                                <img src={selectedProject.image} alt={selectedProject.title} />
                            </div>
                            <div className="modal-right">
                                <h3>{selectedProject.title}</h3>
                                <p>{selectedProject.description}</p>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
}